<template>
  <div class="empty-container">
    <img :style="iconStyle" :src="icon" :alt="tip">
    <p  :style="tipStyle">{{ tip }}</p>
  </div>
</template>

<script>
import {EMPTY_TYPE} from "@/pages/Campaign/utils/enum"
import emptyOffline from '@/pages/Campaign/assets/empty_offline.png'
import emptyWait from '@/pages/Campaign/assets/empty_wait.png'
import {calcRem} from "@/pages/Campaign/utils/calcRem";

export default {
  name: 'Empty',
  props: ['type'],
  data() {
    return {
      iconStyle: {
        width: calcRem(260),
        height: calcRem(200),
        marginTop: calcRem(60)
      },
      tipStyle: {
        fontSize: calcRem(16),
        color: '#8C8C8C',
        textAlign: 'center',
        marginTop: calcRem(30),
      }
    }
  },
  computed: {
    tip() {
      return this.type === EMPTY_TYPE.OFFLINE ? '此页面已下线，去看看其他内容吧～' : '即将上线，敬请期待'
    },
    icon() {
      return this.type === EMPTY_TYPE.OFFLINE ? emptyOffline : emptyWait
    }
  }
}
</script>

<style>
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f6f6f6;
}
</style>
